export const en = {
  // 通用
  common: {
    control: 'Control',
    close: '✕',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit Fullscreen',
    screenSize: 'Screen Size',
    inches: 'inches',
    currentMeasurement: 'Current Measurement',
    diagonal: 'Diagonal',
    window: 'Window',
    fullscreenMode: 'Fullscreen',
  },

  // 设备类型
  deviceType: {
    phone: 'Phone',
    tablet: 'Tablet',
    display: 'Display',
  },

  // 控制面板
  controls: {
    title: 'Control',
    brand: 'Brand',
    model: 'Model',
    selectBrand: 'Select Brand',
    selectModel: 'Select Model',
    screenSizeInches: 'Screen Size (inches)',
    mobileTip: '💡 Mobile devices automatically adapt to screen size',
    unit: 'Unit',
    centimeters: 'Centimeters',
    inches: 'Inches',
  },

  // 品牌
  brands: {
    iPhone: 'iPhone',
    Samsung: 'Samsung',
    Xiaomi: 'Xiaomi',
    Huawei: 'Huawei',
    OPPO: 'OPPO',
    vivo: 'vivo',
    OnePlus: 'OnePlus',
    iPad: 'iPad',
    other: 'Other',
    custom: 'Custom Size',
  },

  // 语言检测
  languageDetection: {
    title: 'Language Detection',
    detected: 'We detected you might be in',
    switchTo: 'Switch to',
    stay: 'Stay in English',
    switch: 'Switch',
  },

  // 尺寸信息
  measurement: {
    current: 'Current Measurement',
    width: 'Width',
    height: 'Height',
    diagonal: 'Diagonal',
    pixels: 'pixels',
  },
}; 